import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { BRAND } from "../lib/data";
import { Loader2, Lock } from "lucide-react";

const field =
  "w-full bg-transparent border-0 border-b border-charcoal/20 rounded-none px-0 py-3 text-lg font-light text-charcoal placeholder:text-stone/50 focus:outline-none focus:border-clay transition-colors";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center px-6">
      <div className="grain-overlay" />
      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-10">
          <img src={BRAND.logo} alt={BRAND.name} className="h-16 w-16 rounded-full object-cover mx-auto" />
          <h1 className="mt-5 font-heading text-4xl font-light text-charcoal">Admin Portal</h1>
          <p className="text-xs uppercase tracking-[0.25em] text-clay mt-2">{BRAND.name}</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-sand-dark rounded-3xl p-8 md:p-10 border border-charcoal/5 shadow-sm flex flex-col gap-7">
          <input data-testid="admin-email" type="email" className={field} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="admin-password" type="password" className={field} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 bg-clay text-sand rounded-full px-8 py-4 font-medium transition-all duration-300 hover:bg-clay-dark hover:-translate-y-0.5 disabled:opacity-60"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={18} strokeWidth={1.5} />}
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <p className="text-center text-sm text-stone mt-6">
          <a href="/" className="hover:text-charcoal transition-colors" data-testid="admin-back-home">← Back to website</a>
        </p>
      </div>
    </div>
  );
}
